import {createSlice} from "@reduxjs/toolkit";

// Initial state
const initialState = {
  showLoader: false,
  showGlobalModal: false,
  modalData: null,
  showHeader: true,
  showFooter: true,
  submitConfirmModal: false,
  cardnoxModal: false,
  dynamicHeaderHeight: 0,
  eSignModal: false,
  claimFormModal: false,
  endorsementFormModal: false,
  exhibitionFormModal: false,
  emiModal: false,
};

// Actual Slice
export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setUiData: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const {
  setShowLoader,
  setNotifyData,
  setMegaMenuData,
  setEventsData,
  setLoginTabActiveKey,
  setUiData,
} = uiSlice.actions;

export const selectUiState = (state) => state.ui;

export default uiSlice.reducer;
